<template lang="pug">
div
    button.change-button(
      :disabled="disabled || loading"
      v-if="showButton"
      @click="show = true"
      @hide="hideModal()"
      data-testid="action-btn-revisar-diagnostico"
    ) Revisar Diagnostico
      b-spinner(v-if="loading" class="ml-2" variant="white" small)
    SamtekModal(
      v-model="show"
      size="lg"
      :title="ot.diagnostico === null ? 'Crear Diagnóstico' : 'Editar Diagnóstico'"
      id="modal-diagnostico"
      @shown="onModalShown"
    )
      b-form-group(
        label-for="input-falla"
        label="¿Se pudo replicar la falla?"
      )
        b-form-radio(v-model="form.replicar_falla" :value="true"
          :state="$v.form.replicar_falla.$dirty ? !$v.form.replicar_falla.$invalid : null" disabled
        ) Sí
        b-form-radio(v-model="form.replicar_falla" :value="false"
          :state="$v.form.replicar_falla.$dirty ? !$v.form.replicar_falla.$invalid : null" disabled
        ) No
      .errors(v-if="$v.form.replicar_falla.$dirty")
        b-form-invalid-feedback(:state="$v.form.replicar_falla.required")
          | Campo requerido
      b-form-group(
        label-for="input-informe"
        label="Diagnóstico:"
      )
        b-form-textarea(
          id="input-informe"
          rows="5"
          v-model="form.informe"
          placeholder="Registrar el diagnóstico (obligatorio)"
          :state="$v.form.informe.$dirty ? !$v.form.informe.$invalid : null")
        .errors(v-if="$v.form.informe.$dirty")
          b-form-invalid-feedback(:state="$v.form.informe.required")
            | Campo requerido
            
      .piezas-sugeridas-section.mt-3(v-if="ot.tipo_servicio && ot.tipo_servicio.id === 4")
        h6.font-weight-bold.mb-2 Repuestos solicitados para cotización:
        div(v-if="loadingPiezas")
          b-spinner(small) 
          span.ml-2 Cargando repuestos...
        div(v-else-if="piezasSugeridas.length > 0")
          div.d-flex.align-items-center.mb-2(v-for="(item, index) in piezasSugeridas" :key="item.id")
            b-form-checkbox.mr-2(v-model="piezasSugeridas[index].seleccionada" style="margin-top: 2px;")
            span {{ item.descripcion || item.codigo }}
        p.text-muted.small(v-else) No hay repuestos solicitados por el técnico para esta OT.
            
      .servicios-sugeridos-section.mt-4(v-if="ot.tipo_servicio && ot.tipo_servicio.id === 4")
        h6.font-weight-bold.mb-2 Servicios solicitados para cotización:
        div(v-if="loadingServicios")
          b-spinner(small) 
          span.ml-2 Cargando servicios...
        div(v-else-if="serviciosSugeridos.length > 0")
          div.d-flex.align-items-center.mb-2(v-for="(item, index) in serviciosSugeridos" :key="item.id")
            b-form-checkbox.mr-2(v-model="serviciosSugeridos[index].seleccionada" style="margin-top: 2px;")
            span.flex-grow-1 {{ item.nombre }}
            span.mr-3 ${{ item.precio.toLocaleString('es-CL') }}
            b-form-input(type="number" v-model="serviciosSugeridos[index].cantidad" min="1" size="sm" placeholder="Cant." style="width: 70px")
        p.text-muted.small(v-else) No hay servicios configurados para seleccionar.
            
      template(#modal-footer='{ ok, cancel, hide }')
        div.d-flex.justify-content-between.w-100
          //- Left side: Cancel and Reject
          div.d-flex
            b-button.btn-samtek-secondary.mr-2(size='sm' variant='light' @click='hideModal()') Cancelar
            b-button.btn-samtek-secondary(size='sm' variant='light' @click='reject()') Rechazar
          
          //- Right side: Approve (Primary)
          div
            b-button.btn-samtek-primary(
              size='sm' 
              @click='saveDiagnostic()' 
              :disabled="loading" 
              data-testid="modal-approve-diagnostico"
            ) Aprobar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import OTUploads from '../OTUploads.vue'

export default {
  components: {
    OTUploads,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  mixins: [LoadingButtonMixin],
  name: 'ActionDiagnosticoPorRevisar',
  props: ['ot', 'disabled'],

  validations: {
    form: {
      replicar_falla: { required },
      informe: { required },
    },
  },
  data() {
    return {
      show: false,
      showButton: true,
      loadingPiezas: false,
      piezasSugeridas: [],
      loadingServicios: false,
      serviciosSugeridos: [],
      form: {
        replicar_falla: this.ot.diagnostico_detail
          ? this.ot.diagnostico_detail.replicar_falla
          : null,
        informe: this.ot.diagnostico_detail
          ? this.ot.diagnostico_detail.informe
          : null,
        id: this.ot.diagnostico_detail ? this.ot.diagnostico_detail.id : null,
        orden_trabajo: this.ot.ot,
        presupuesto_aceptado: true,
      },
    }
  },
  methods: {
    ...mapActions('Diagnosticos', [
      'createDiagnoseOT',
      'updateDiagnoseOT',
      'rejectDiagnostic',
      'approveDiagnoseOT',
      'getPiezasSugeridas',
      'getServiciosSeleccionables',
    ]),
    ...mapActions('OTStore', ['getOT']),
    hideModal() {
      this.show = false
    },
    async onModalShown() {
      if (this.ot.tipo_servicio && this.ot.tipo_servicio.id === 4) {
        this.loadingPiezas = true
        try {
          const partesSolicitadas = (this.ot.solicitud_partes || []).filter(
            (sp) => !['Dropped', 'Part failed'].includes(sp.estado)
          )
          const grouped = {}
          partesSolicitadas.forEach((sp) => {
            const parteId = sp.parte.id
            if (!grouped[parteId]) {
              grouped[parteId] = {
                id: parteId,
                codigo: sp.parte.part_number,
                descripcion: sp.parte.description,
                seleccionada: true,
              }
            }
          })
          let piezas = Object.values(grouped)
          const resp = await this.getPiezasSugeridas(this.ot.ot)
          if (resp && resp.status === 200) {
            const savedIds = new Set(
              (resp.data.piezas_sugeridas || []).map((p) => p.id)
            )
            if (savedIds.size > 0) {
              piezas = piezas.map((p) => ({
                ...p,
                seleccionada: savedIds.has(p.id),
              }))
            }
          }
          this.piezasSugeridas = piezas
        } catch (e) {
          console.error('Error al cargar repuestos solicitados:', e)
        } finally {
          this.loadingPiezas = false
        }

        this.loadingServicios = true
        try {
          const resp = await this.getServiciosSeleccionables()
          if (resp && resp.status === 200) {
            const dataList = resp.data.results || resp.data || []
            this.serviciosSugeridos = dataList.map((s, idx) => ({
              index: idx,
              id: s.id,
              nombre: s.nombre,
              precio: s.precio,
              cantidad: 1,
              seleccionada: false, // Desmarcados por defecto según instrucción
            }))
          }
        } catch (e) {
          console.error('Error al cargar servicios disponibles:', e)
        } finally {
          this.loadingServicios = false
        }
      }
    },
    async reject() {
      try {
        await this.executeWithLoading(async () => {
          const response = await this.rejectDiagnostic({
            ...this.form,
          })
          if (response.status === 200) {
            this.$bvToast.toast(response.data.mensaje, {
              variant: 'success',
            })
            await this.getOT(this.ot.ot)
            this.$emit('changed')
          } else {
            this.$bvToast.toast(
              `Error al guardar el diagnóstico: ${response.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al rechazar diagnóstico:', error)
      }
    },
    async saveDiagnostic() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
        return
      }

      try {
        await this.executeWithLoading(async () => {
          // DAT01: Usar endpoint dedicado que registra fecha_aprobacion_diagnostico
          this.form.presupuesto_aceptado = true
          const payload = { ...this.form }
          if (this.ot.tipo_servicio && this.ot.tipo_servicio.id === 4) {
            payload.partes_sugeridas = this.piezasSugeridas
              .filter((p) => p.seleccionada)
              .map((p) => ({
                id: p.id,
                cantidad: 1,
              }))
            payload.servicios_sugeridos = this.serviciosSugeridos
              .filter((s) => s.seleccionada)
              .map((s) => ({
                id: s.id,
                cantidad: parseInt(s.cantidad, 10) || 1,
              }))
          }
          const response = await this.approveDiagnoseOT({
            diagnosticoId: this.form.id,
            data: payload,
          })
          if (response.status === 200) {
            this.$bvToast.toast('Diagnóstico aprobado.', {
              variant: 'success',
            })
            await this.getOT(this.ot.ot)
            this.$emit('changed')
            this.show = false
          } else if (response.status === 404) {
            this.$bvToast.toast('Diagnóstico no encontrado (404).', {
              variant: 'danger',
            })
          } else {
            this.$bvToast.toast(
              `Error al aprobar el diagnóstico: ${response.data}`,
              {
                variant: 'danger',
              }
            )
          }
        })
      } catch (error) {
        console.error('Error al guardar diagnóstico:', error)
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OTStore', ['statusRequest']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,
  },
}
</script>

<style lang="scss" scoped>
.preview,
.capture {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
img {
  width: 100%;
}
.webcam {
  display: inline-flex;
  justify-content: space-between;
  margin: -8pxl;
}
.form-group {
  min-height: 100% !important;
}
</style>
